import React from "react";
import "../../graphStyles.scss";
import { GraphDropDown } from "../../GraphDropDown";
import NoDataFound from "../../../NoDataFound";
import { LoadingAnimation } from "../../../Loading/LoadingAnimation";
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Filler,
  Tooltip,
  LineController,
  BarController,
} from "chart.js";
import { Chart } from "react-chartjs-2";

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  Filler,
  BarController
);

export function VisitorNumbersByOverallUTM({
  display,
  weeks,
  visitors,
  percentOfBooking,
  nameLabels,
  totalSales,
  loading,
}) {
  const [currentWeek, setCurrentWeek] = React.useState(0);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        onHover: function (event, legendItem) {
          document.getElementById("chart8").style.cursor = "pointer";
        },
        onLeave: function (event, legendItem) {
          document.getElementById("chart8").style.cursor = "default";
        },
        labels: {
          filter: (l) => l.text !== "none",
        },
      },
    },
    scales: {
      x: {
        title: {
          text: "UTM Overall Category",
          display: true,
          font: {
            size: 13.5,
          },
        },
        grid: {
          display: false,
        },
      },
      y: {
        position: "left",
        title: {
          text: "Number of visitors",
          display: true,
          font: {
            size: 13.5,
          },
        },
      },
      y1: {
        position: "right",
        title: {
          text: "Number of visitors",
          display: true,
          font: {
            size: 13.5,
          },
        },
      },
    },
  };

  const labels = nameLabels[currentWeek];

  const data = {
    labels,
    datasets: [
      {
        label: "Number of visitors who booked in this cohort",
        data: percentOfBooking[currentWeek],
        yAxisID: "y1",
        borderColor: "rgba(250, 210, 90, 0.99)",
        backgroundColor: "rgba(250, 210, 90, 0.99)",
        hoverBackgroundColor: "rgba(250, 210, 90, 0.99)",
        order: 0,
        type: "line",
        pointRadius: 3,
        lineTension: 0.4,
      },
      {
        label: "Number of visitors",
        data: visitors[currentWeek],
        backgroundColor: "rgba(12, 200, 255, 0.99)",
        hoverBackgroundColor: "rgba(12, 200, 255, 0.99)",
        yAxisID: "y",
        order: 1,
      },
      {
        label: "Number of visitors who bought in this cohort",
        data: totalSales[currentWeek],
        yAxisID: "y1",
        type: "line",
        lineTension: 0.4,
        borderColor:
          totalSales[currentWeek] === undefined
            ? "none"
            : totalSales[currentWeek].length !== 1
            ? "rgba(255,120,0,1)"
            : "rgba(0,0,0,0)",
        backgroundColor:
          totalSales[currentWeek] === undefined
            ? "none"
            : totalSales[currentWeek].length !== 1
            ? "rgba(255,120,0,1)"
            : "rgba(0,0,0,0)",
        hoverBackgroundColor:
          totalSales[currentWeek] === undefined
            ? "none"
            : totalSales[currentWeek].length !== 1
            ? "rgba(255,120,0,1)"
            : "rgba(0,0,0,0)",
      },
    ],
  };

  return (
    <>
      {loading ? (
        <LoadingAnimation />
      ) : (
        <div className="graph">
          <div className="graph__title flex flex-col md:flex-row justify-between items-center">
            <h4 className="text-lg md:text-xl font-semibold text-center md:text-left mb-2 md:mb-0">
            Number of visitors through UTM overall category
            </h4>
            <GraphDropDown
              display={display}
              currentWeek={currentWeek}
              setCurrentWeek={setCurrentWeek}
              weeks={weeks}
              className="w-full md:w-auto"
            />
          </div>

          {weeks.length === 0 ? (
            <NoDataFound />
          ) : (
            <div className="relative w-full" style={{ height: "300px" }}>
              <Chart
                className="chart"
                id="chart8"
                type="bar"
                options={options}
                data={data}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
}
